var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3854 12.9458C8.73512 15.0685 4.85569 14.9014 2.3989 12.4446C-0.237135 9.80856 -0.237135 5.5347 2.3989 2.89866C5.03494 0.262621 9.30881 0.262621 11.9448 2.89866C14.4016 5.35544 14.5687 9.23487 12.446 11.8851L17.6017 17.0408C17.8946 17.3337 17.8946 17.8085 17.6017 18.1014C17.3088 18.3943 16.8339 18.3943 16.541 18.1014L11.3854 12.9458ZM3.45956 11.3839C1.40931 9.33369 1.40931 6.00957 3.45956 3.95932C5.50982 1.90907 8.83393 1.90907 10.8842 3.95932C12.9329 6.00807 12.9344 9.32881 10.8887 11.3794C10.8872 11.3809 10.8857 11.3824 10.8842 11.3839C10.8827 11.3854 10.8812 11.3869 10.8797 11.3884C8.82906 13.4342 5.50831 13.4327 3.45956 11.3839Z",
    fill: "#919CA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.98f579b1fc1eec3ea152c09bc64b149d.svg";
export { ForwardRef as ReactComponent };